export const BASIC_URL = `${process.env.REACT_APP_BASIC_URL ?? ""}/api`;
